import type { Fields } from '@puckeditor/core';

import { createSpacingFields } from './spacing-fields';
import type { BoxSpacing } from './tokens';
import { toggleField } from './widgets/toggle-field';

export type MobilePaddingProps = {
  differentMobilePadding: boolean;
  mobilePadding: BoxSpacing;
};

export function createMobilePaddingFields(): Fields<MobilePaddingProps> {
  return {
    differentMobilePadding: toggleField('Different mobile padding'),
    mobilePadding: {
      type: 'object',
      label: 'Mobile padding',
      objectFields: createSpacingFields(),
    },
  };
}

/** Hiding the controls leaves their saved values intact for the next time the toggle is enabled. */
export function resolveMobilePaddingFields<Props extends MobilePaddingProps>(
  enabled: unknown,
  fields: Fields<Props>
): Fields<Props> {
  if (enabled === true) return fields;

  return Object.fromEntries(Object.entries(fields).filter(([name]) => name !== 'mobilePadding')) as Fields<Props>;
}
